<template>
    <div id="sticky-sidebar" class="sidebar-wrapper">
        <aside>
            <div class="mb-10"></div>
            <div class="room-page-right-sidebar">
                <div class="room-page-heading">
                    <div class="meta-option clearfix mt-10">
                        <div class="raty-wrapper sp-2 mb-5">
                            <div class="star-rating-12px" data-rating-score="4"></div>
                        </div>
                    </div>
                    <h4>VolaRoom</h4>
                    <p><i class="fa fa-map-marker text-primary"></i> Lleida, España</p>
                </div>
                <div class="image">
                    <img src="../../assets/images/IMG_1219.jpg" alt="image">
                </div>
                <div class="content mb-30">
                    <h5>Fechas <a data-toggle="modal" href="#changeDateModal" class="link-danger">
                        <font-awesome-icon icon="search"/>
                        Cambiar Fechas</a></h5>
                    <ul>
                        <li class="clearfix">
                            <span class="absolute">Check-in: </span>
                            friday, 14 Jun, 2019 18:00
                        </li>
                        <li class="clearfix">
                            <span class="absolute">Check-out: </span>
                            friday, 14 Jun, 2019 20:00
                        </li>
                    </ul>
                </div>
                <div class="content mb-30">
                    <h5>Price</h5>
                    <ul class="inverse">
                        <li class="clearfix">
                            <span class="absolute">14.00€</span>
                            2horas, 1Sala
                        </li>
                    </ul>
                </div>
                <div class="content total-price">
                    <h5>Total <span>14,00€</span></h5>
                </div>
            </div>
            <div class="mb-30"></div>
        </aside>
    </div>
</template>

<script>
    export default {
        name: "rightInfo"
    }
</script>

<style scoped>

</style>